const state = {
	mobileSideBar:false,
	isMobileMode:false,
	rightToolBar:false
}
  
const mutations = {
	ToggleMobileSideBar(state){
		state.mobileSideBar = !state.mobileSideBar
		state.mobileSideBar ? state.rightToolBar = false:state.rightToolBar = state.rightToolBar
	},
	CloseMobileSideBar(state){
		state.mobileSideBar = false
	},
	ToggleToolBar(state){
		state.rightToolBar = !state.rightToolBar
		state.rightToolBar ? state.mobileSideBar = false:state.mobileSideBar = state.mobileSideBar
	},
	CloseToolBar(state){
		state.rightToolBar = false
	},
	setMobileMode(state,mode){
		state.isMobileMode = mode
	}
}

const actions = {

}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
  